// extracted by mini-css-extract-plugin
export default {"receipt":"receipt--Fv3vV"};